import { ILCE_LISTESI } from "../constants/requestUrls";
import { getRequest } from "../request";

const ilceList = () => {
    const data = {};
    return getRequest({ url: ILCE_LISTESI, data });
}

export default ilceList;